// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-anim[data-v-824f7a60]{overflow:hidden;transition:all .25s ease}.mobile-nav[data-v-824f7a60]{z-index:950;white-space:nowrap}.rotate-y[data-v-824f7a60]{transform:rotate(135deg)}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ie-srf[data-v-824f7a60]{height:45px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
